import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import useStores from './useStores';
import getLoginFormComponent from './getLoginFormComponent';
import getLayoutComponent from './getLayoutComponent';
import getRouteConfiguration from './getRouteConfiguration';
import { useRouter } from 'next/router';
import withStores from '@studionand/ada-next/src/stores/withStores';
import hoistNonReactStatics from 'hoist-non-react-statics';

const ContextLayout = observer(props => {
  const { isLoggedIn, component: Component, appStore, ...restProps } = props;
  const router = useRouter();
  const { uiStore, dataStore } = useStores();
  const LayoutComp = getLayoutComponent(uiStore.context);
  const LoginForm = getLoginFormComponent(uiStore.context);
  const config = getRouteConfiguration(uiStore.context);
  const [initialProps, setInitialProps] = React.useState({ errorCode: null });

  const getInitialProps = async () => {
    if (Component.getInitialProps) {
      const getInitialProps =
        Component.displayName !== 'NamedPageContent'
          ? Component.getInitialProps
          : Component.getInitialProps(config);
      getInitialProps({
        config,
        dataStore,
        uiStore,
        adaStores: {
          appStore,
        },
        query: router.query,
      }).then(r => {
        setInitialProps(r);
      });
    }
  };
  return (
    <React.Fragment>
      {!isLoggedIn && (
        <LayoutComp>
          <LoginForm getInitialProps={getInitialProps} />
        </LayoutComp>
      )}
      {isLoggedIn && <Component {...restProps} {...initialProps} />}
    </React.Fragment>
  );
});

function withAuth(Component) {
  @withStores('loginStore', 'appStore')
  @observer
  class Auth extends React.Component {
    static propTypes = {
      loginStore: PropTypes.object.isRequired,
    };
    render() {
      const { loginStore, appStore, ...restProps } = this.props;
      return (
        <ContextLayout
          appStore={appStore}
          component={Component}
          isLoggedIn={loginStore.isLoggedIn}
          {...restProps}
        />
      );
    }
  }

  return hoistNonReactStatics(Auth, Component);
}

export default withAuth;
